import React from 'react'

const Empty = () => {
    return (
        <div className="w-full flex justify-center items-center lg:py-0 py-20 h-full">
            <div className="max-w-md mx-auto">
                <img
                    className="mx-auto w-64"
                    src="https://storage.googleapis.com/assets-us-east4-propilatam-dev/website-assets/propi-web/not-result.svg"
                    alt="not-found"
                />
                <p className="font-semibold text-lg text-[#212121] text-center mt-4">
                    Lo sentimos, parece ser que no contamos con
                    unidades con las características seleccionadas.
                </p>
                <p className="text-center font-medium text-base text-[#757575]">
                    Prueba ajustando algunos filtros
                </p>
            </div>
        </div>
    )
}

export default Empty